import { render, staticRenderFns } from "./TableEducationLevel.vue?vue&type=template&id=32c417e2"
import script from "./TableEducationLevel.vue?vue&type=script&lang=js"
export * from "./TableEducationLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports